// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".camera{overflow:hidden;width:100%;height:100%}", "",{"version":3,"sources":["webpack://./src/components/Camera/Camera.scss"],"names":[],"mappings":"AAAA,QACE,eAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".camera {\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
